import { AnalyticIdentifier } from '@common/neo.tax';

import { useAnalyticId } from '@neo.tax/shared';

type AccountingQreLayoutAnalyticIds = {
  bulkEditInExcelBtnId: string;
  connectProviderBtnId: string;
  setAccountingRdPercentageBtnId: string;
};

export const useAccountingQreLayoutAnalyticIds = (): AccountingQreLayoutAnalyticIds => ({
  bulkEditInExcelBtnId: useAnalyticId(AnalyticIdentifier.ACCOUNTING_QRE_LAYOUT_BULK_EDIT_IN_EXCEL_BTN),
  connectProviderBtnId: useAnalyticId(AnalyticIdentifier.ACCOUNTING_QRE_LAYOUT_CONNECT_PROVIDER_BTN),
  setAccountingRdPercentageBtnId: useAnalyticId(AnalyticIdentifier.ACCOUNTING_QRE_LAYOUT_SET_RD_PERCENTAGE_BTN),
});
